import { z } from "zod";

/**
 * Lead-to-cash funnel + SLA contract — GET /v2/analytics/funnel and
 * GET /v2/analytics/sla (V2 Builder 5, docs/V2_FEATURES_PLAN.md). Every
 * number here is server-computed in app/services/funnel.py — this file
 * never re-derives a stage count, conversion rate, forecast, or SLA
 * percentile client-side, per the house rule that counts/money are
 * server-authoritative.
 */

// ---- Funnel -------------------------------------------------------------------

export const FunnelStageSchema = z.object({
  name: z.string(),
  count: z.number(),
  conversion_from_previous_pct: z.number().nullable(),
});
export type FunnelStage = z.infer<typeof FunnelStageSchema>;

export const FunnelSchema = z.object({
  stages: z.array(FunnelStageSchema),
  forecast_cents: z.number(),
});
export type Funnel = z.infer<typeof FunnelSchema>;

/** Server-side stage names, in funnel order — used to give each stage a
 * human label without re-deriving anything numeric. */
export const FUNNEL_STAGE_LABELS: Record<string, string> = {
  inquiries_created: "Inquiries",
  quotes_sent: "Quotes sent",
  quotes_viewed: "Quotes viewed",
  quotes_accepted: "Quotes accepted",
  events_booked: "Events booked",
  events_delivered: "Events delivered",
  invoices_paid: "Invoices paid",
};

// ---- SLA ------------------------------------------------------------------------

export const SlaStatsSchema = z.object({
  total_inquiries: z.number(),
  answered_count: z.number(),
  median_response_minutes: z.number(),
  p90_response_minutes: z.number(),
  pct_within_sla: z.number(),
});
export type SlaStats = z.infer<typeof SlaStatsSchema>;
